import { render, staticRenderFns } from "./HeaderCatalogo.vue?vue&type=template&id=16acceda"
import script from "./HeaderCatalogo.vue?vue&type=script&lang=js"
export * from "./HeaderCatalogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports